import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import { Link } from "gatsby"

import BackInStockPopup from "../../Product/BackInStock/BackInStockPopup"
import { Image } from "../../Image/Image"
//import { StyledButton } from "../../Styled/Button"
import { Price } from "../../Price/Price"
//import AddToCart from "../AddToCart/AddToCart"
import { withFeaturedProductCard } from "./withFeaturedProductCard"
import { StyledH2 } from "../../Styled/Text"
import { Badge } from "../../Icon/Badge"
import SelectorGrid from "./../Selector/SelectorGrid"
import { useCheckoutContext } from "../../../hooks/useCheckout"

// const styles = {
//   textSize: {
//     collection: "sm-tight",
//     default: "26",
//   },
//   colour: {
//     lightest: "lightest",
//     light: "light",
//     beige: "beige",
//     pink: "pink",
//   },
// }
const Wrapper = styled.div`
  ${({ isOneHalf }) => (isOneHalf ? tw`w-full md:w-3/4` : tw`w-full`)}
  ${tw`relative py-1-6 px-0-8 md:px-1-6 md:pb-3-2`}
`
// const Details = styled.div`
//   ${tw`flex flex-col justify-center mb-1 pt-2-4`}
// `
const Details = styled.div`
  ${tw`flex flex-col justify-center mb-1 pt-4`}
`
const TitleSection = tw.div`md:flex md:flex-row md:justify-between md:items-start`
const Title = styled(StyledH2)`
  ${tw`text-left mb-1 min-h-5 whitespace-normal`}
`
const PriceSection = tw.div`md:flex md:justify-center md:items-center mb-1`
const PriceWrapper = tw.div`md:text-right md:flex`

const ImageWrapper = tw(Link)`relative block`
//const TagWrapper = tw.div`absolute top-0 left-0 w-full p-1/12 md:p-4 flex items-stretch justify-between z-10`

const SelectorSection = tw.div`mb-2 md:max-w-2/3`
const BadgeWrapper = tw.div`absolute bottom-0 left-0 w-full p-1/12 md:p-4 flex items-stretch justify-start z-10`
const ItemImage = styled.div<ItemImageProps>`
  ${tw`absolute duration-slow inset-0 w-full h-full cursor-pointer`}
  ${({ display }) => (display ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
`
const CustomImage = tw.img`object-cover absolute duration-slow inset-0 w-full h-full cursor-pointer`
export const ItemImageRatio = styled.div`
  ${tw`block bg-transparent`}
  padding-top:calc(100%)
`
export const CustomItemImageRatio = styled.div`
  ${tw`block bg-transparent`}
  padding-top: calc(64.6%);
`
const FeaturedProductCard = withFeaturedProductCard(
  ({
    isOneHalf,
    product,
    //productCategory,
    isPackProduct,
    colours,
    image,
    hoverImage,
    link,
    title,
    handleClick, //shapeTag, //material, //sizeTag,
    badge,
    selectedVariant,
    type,
    //    outOfStock,
    active,
    setActive,
    displayHover,
    handleHover,
    itemRef,
    selectedProduct,
  }) => {
    const { checkout } = useCheckoutContext()
    const presentmentPrice = (selectedVariant ?? product?.variants?.[0])?.presentmentPrices?.find(
      item => item?.price?.currency_code === (checkout?.currencyCode ?? "AUD") || item?.price?.currencyCode === (checkout?.currencyCode ?? "AUD")
    )

    return (
      <>
        <Wrapper isOneHalf={isOneHalf} onClick={handleClick}>
          <ImageWrapper ref={itemRef} onMouseEnter={() => handleHover(true)} onMouseLeave={() => handleHover(false)} to={link} title={title}>
            {isOneHalf ? (
              <>
                <CustomItemImageRatio />
                <CustomImage src={image?.asset.url} alt={image?.alt} />
              </>
            ) : (
              <>
                <ItemImageRatio />
                <ItemImage display={!displayHover}>
                  <Image background={`lightest`} image={image} alt={image?.alt ? image.alt : `${title}`} ratio={`1/1`} />
                </ItemImage>
                <ItemImage display={displayHover}>
                  <Image background={`lightest`} image={hoverImage} alt={hoverImage?.alt ? hoverImage.alt : `${title}`} ratio={`1/1`} />
                </ItemImage>
              </>
            )}
            {!product.tags_productgroup || product.tags_productgroup[0] != "giftcard" ? (
              product.tags[1] != "productGroup:giftcard" ? (
                badge?.colour && badge?.text ? (
                  <BadgeWrapper>
                    <Badge colour={badge?.colour} text={badge?.text} />
                  </BadgeWrapper>
                ) : null
              ) : null
            ) : null}
          </ImageWrapper>
          <Details>
            <TitleSection>
              <Title className="body_regular" type={type}>
                <Link to={link} title={title}>
                  {title}
                </Link>
              </Title>
              <PriceSection>
                <Link to={link} title={title}>
                  <PriceWrapper>
                    <Price
                      price={presentmentPrice?.price ?? {}}
                      compareAtPrice={presentmentPrice?.compare_at_price ?? {}}
                      layout={`collection`}
                      className="body_regular"
                    />
                  </PriceWrapper>
                </Link>
                {/* <SubtitleWrapper>{material}</SubtitleWrapper> */}
              </PriceSection>
            </TitleSection>
          </Details>
          {!isPackProduct && product?.variants?.length && colours.length ? (
            <SelectorSection>
              <SelectorGrid
                size="smallSelector"
                variants={product.variants}
                product={product}
                selectedVariant={selectedVariant}
                colours={colours}
                selectedProduct={selectedProduct}
              />
            </SelectorSection>
          ) : null}
        </Wrapper>
        <BackInStockPopup selectedVariant={selectedVariant} active={active} setActive={setActive} />
      </>
    )
  }
)

export default FeaturedProductCard

type ItemImageProps = {
  display: boolean
}
